import React from "react";
import DropProps from "../DropProps";

export default ({children, ...props}) => (
  <DropProps {...props} drop={['resource', 'basePath']}>
    {children}
  </DropProps>
)